import { breakpoints } from '@notino/react-styleguide';

import { styled } from '@linaria/react';

export const FiltersWrapper = styled.div`
  display: flex;
  gap: 0.5rem;

  overflow-x: scroll;
  scrollbar-width: none;
  margin-top: 2rem;

  @media (min-width: ${breakpoints.md}) {
    margin-top: 2.5rem;
  }
`;
